import { render, staticRenderFns } from "./CompanyEmployeeData.vue?vue&type=template&id=2c965c5c"
import script from "./CompanyEmployeeData.vue?vue&type=script&lang=js"
export * from "./CompanyEmployeeData.vue?vue&type=script&lang=js"
import style0 from "./CompanyEmployeeData.vue?vue&type=style&index=0&id=2c965c5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports